import { t } from 'i18next'
import { ToastEventPayload } from '~/hooks/toast/useToastAlerts'
import {
  NotificationDomain,
  NotificationPayload,
} from '~/services/EventEmitter/types/NotificationEmitterTypes'

export enum ContactsOperation {
  ContactNumberCopiedToClipboard = 'contactNumberCopiedToClipboard',
}

const getContactNumberCopiedToClipboardEvent = (
  payload: NotificationPayload<NotificationDomain.CONTACTS>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('contactsPage.toast.copyNumberSuccess')
      break
    case 'red.solid':
      title = t('contactsPage.toast.copyNumberError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

export const getContactsToastEvent = (
  payload: NotificationPayload<NotificationDomain.CONTACTS>,
) => {
  switch (payload.operation) {
    case ContactsOperation.ContactNumberCopiedToClipboard:
      return getContactNumberCopiedToClipboardEvent(payload)
    default:
      return null
  }
}
